import React from "react";
import {Alert} from "react-bootstrap";

interface ErrorsAlertProps{
    error_list?: string[];
    show_head?:boolean;
    head_title?:string;
}

const ErrorsAlert: React.FC<ErrorsAlertProps> = (
    {
        error_list = [],
        show_head = true,
        head_title = 'エラー',
    }
) => {
  if(error_list && error_list.length != 0){
      return (
          <Alert variant="danger" style={{textAlign: 'left'}}>
              {show_head && <Alert.Heading>{head_title}</Alert.Heading>}
              {error_list.map( (err, idx) => <p key={`alert_error_${idx}`}>
                  {err}
              </p>)}
          </Alert>
      );
  }else {
      return <></>;
  }

};
export default ErrorsAlert;